import { render, staticRenderFns } from "./new-match.vue?vue&type=template&id=5bd94166&"
import script from "./new-match.vue?vue&type=script&lang=js&"
export * from "./new-match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports